/**
 * @fileoverview POST handler for the "/:app_group_id/conversational/tool_definition" endpoint
 */
import { exhaustiveCheck } from "@lib/exhaustiveCheck";
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { conversationalToolDefinitionCacheKeys } from "./constants";
import type {
  ConversationalToolDefinitionResult,
  PostConversationalToolDefinitionErrors,
  PostConversationalToolDefinitionProps,
} from "./types";

const buildCreateParams = (props: PostConversationalToolDefinitionProps): Record<string, unknown> => {
  switch (props.type) {
    case "workflow_attribute":
      return {
        type: props.type,
        name: props.name,
        description: props.description,
        data_type: props.dataType,
        allowed_values: props.allowedValues,
      };
    case "webhook":
      return {
        type: props.type,
        name: props.name,
        description: props.description,
        request_method: props.requestMethod,
        url: props.url,
        body: props.body,
        headers: props.headers,
        credential_name: props.credentialName,
        variables: props.variables,
        response_fields: props.responseFields,
      };
    case "custom_attribute":
      return {
        type: props.type,
        name: props.name,
        description: props.description,
        attribute_name: props.attributeName,
        source: props.source,
        source_id: props.sourceId,
      };
    case "custom_event":
      return {
        type: props.type,
        name: props.name,
        description: props.description,
        event_name: props.eventName,
        properties: props.properties,
      };
    case "knowledge_source_search":
      return {
        type: props.type,
        name: props.name,
        description: props.description,
        knowledge_source_definition_id: props.knowledgeSourceDefinitionId,
        excluded_fields: props.excludedFields,
      };
    default:
      exhaustiveCheck(props);
      return {};
  }
};

export const postConversationalToolDefinition = reactQueryMutationAdapter(
  conversationalToolDefinitionCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostConversationalToolDefinitionErrors>()(
    (props: PostConversationalToolDefinitionProps): Promise<ConversationalToolDefinitionResult> => {
      return fetch(
        `/${props.appGroupId}/conversational/tool_definition`,
        "POST",
        buildCreateParams(props),
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
